import { HttpHeaders, HttpParams } from '@angular/common/http';

export const HTTP_HEADERS_FOR_NON_AUTH_API = {
  params: {} as HttpParams,
  headers: {} as HttpHeaders,
  attachTenantId: false,
};
